const CruzImagenPrevia = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="#1A1A1A" />
      <path d="M6 6.4502L17.7453 18.0005" stroke="white" strokeWidth="2" />
      <path d="M18 6L6.25473 17.5503" stroke="white" strokeWidth="2" />
    </svg>
  );
};

export default CruzImagenPrevia;
